import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// 企业微信-企业内部应用-鉴权相关
import { pick, versionCompare } from '../tools';
import { browser } from '../const';
import { loadWxAgentConfig } from '../service/config';
import { WxConfig } from './wx.config';
import protocol from '../protocol/wx.protocol';
import { EcoType } from '../const/enums';
import qywxJsApi from './jsApi/qywx.apilist'; // wx.agentConfig 接口列表

var jsApiList = qywxJsApi.all; // 企业微信鉴权相关的JS依赖
// const agentdkPath = 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js';

export var QywxConfig = /*#__PURE__*/function (_WxConfig) {
  _inheritsLoose(QywxConfig, _WxConfig);

  function QywxConfig(options) {
    var _this;

    _this = _WxConfig.call(this, options) || this; // 当前环境是否支持 config 鉴权

    _this.protocol = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protocolName, data) {
        var isInvokeApi;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (jsApiList.includes(protocolName)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.wxProtocol(protocolName, data));

              case 2:
                if (!qywxJsApi.authority.includes(protocolName)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.onAgentReady();

              case 5:
                isInvokeApi = qywxJsApi.invoke.includes(protocolName);
                return _context.abrupt("return", protocol(protocolName, data, isInvokeApi));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.configType = EcoType.qywx;
    _this.isWxServe = false;
    _this.support = !!browser.qywx; // SDK是否准备就绪

    _this.qywxSdkReady = false; // 是否成功 agent 鉴权

    _this.agentOK = false; // 最后一次鉴权成功的时间，timeSpans

    _this.lastWxAgentConfigTime = null; // 通过当前类初始化的对象，一定是企业微信自建应用，不是服务号/公众号

    _this.isWxServe = false;
    return _this;
  }
  /**
   *  当前生态配套的统一协议入口
   *  接口分：微信SDK（wx.*** 协议分需要/不需要鉴权），企业微信SDK（wx.invoke('****')）
   * @param protocolName 协议名称
   * @param data 参数对象
   * @returns Premise
   */


  var _proto = QywxConfig.prototype;

  // onReady 使用基类 wxConfig的方法，企业微信内部，调用少量SDK时会自动触发企微鉴权
  // async onReady()

  /**
   * 企业微信应用鉴权，自建应用的某些接口会有额外鉴权
   * @returns  this.agentOK:agent 鉴权是否成功
   */
  _proto.onAgentReady =
  /*#__PURE__*/
  function () {
    var _onAgentReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var wxConfigReady;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (browser.qywx) {
                _context2.next = 3;
                break;
              }

              this.log('not qywx browser');
              return _context2.abrupt("return", false);

            case 3:
              if (!versionCompare(browser.qywx.version, '2.5.0', false)) {
                _context2.next = 6;
                break;
              }

              this.log('this qywx browser does not support, the support version: 2.5.0 ');
              return _context2.abrupt("return", false);

            case 6:
              _context2.next = 8;
              return this.onReady();

            case 8:
              wxConfigReady = _context2.sent;

              if (wxConfigReady) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", false);

            case 11:
              _context2.next = 13;
              return this.loadQywxSDK();

            case 13:
              this.qywxSdkReady = _context2.sent;
              _context2.next = 16;
              return this.agentConfig();

            case 16:
              this.agentOK = _context2.sent;
              return _context2.abrupt("return", this.agentOK);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function onAgentReady() {
      return _onAgentReady.apply(this, arguments);
    }

    return onAgentReady;
  }() // 加载企业微信SDK
  ;

  _proto.loadQywxSDK =
  /*#__PURE__*/
  function () {
    var _loadQywxSDK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = this.qywxSdkReady;

              if (_context3.t0) {
                _context3.next = 5;
                break;
              }

              _context3.next = 4;
              return QywxConfig.loadSDK();

            case 4:
              _context3.t0 = _context3.sent;

            case 5:
              this.qywxSdkReady = _context3.t0;
              return _context3.abrupt("return", this.qywxSdkReady);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function loadQywxSDK() {
      return _loadQywxSDK.apply(this, arguments);
    }

    return loadQywxSDK;
  }();

  _proto.agentConfig = /*#__PURE__*/function () {
    var _agentConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this2 = this;

      var orgId, agentId, configRes, newConfig, myWxAgentConfig, configOK;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              orgId = this.orgId;
              agentId = this.agentId;

              if (browser.qywx) {
                _context4.next = 5;
                break;
              }

              this.log('agentConfig: not qywx client');
              return _context4.abrupt("return", false);

            case 5:
              if (!this.agentOK) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", this.agentOK);

            case 7:
              _context4.next = 9;
              return loadWxAgentConfig({
                agentId: agentId,
                orgId: orgId
              });

            case 9:
              configRes = _context4.sent;

              if (configRes) {
                _context4.next = 13;
                break;
              }

              console.error('load qywx agentConfig error', configRes);
              return _context4.abrupt("return", false);

            case 13:
              newConfig = pick(configRes, [['appId', 'corpid'], 'timestamp', ['noncestr', 'nonceStr'], 'signature']);
              newConfig.agentid = agentId;

              myWxAgentConfig = function myWxAgentConfig() {
                return new Promise(function (resolve, reject) {
                  window.wx.agentConfig(_extends({}, newConfig, {
                    jsApiList: jsApiList.concat(_this2.apiList),
                    success: function success(res) {
                      resolve(res);
                    },
                    fail: function fail(res) {
                      console.error(res.errMsg);
                      reject(res);
                    }
                  }));
                });
              };

              _context4.next = 18;
              return myWxAgentConfig().then(function () {
                // 记录最后一次鉴权成功的时间点
                _this2.lastWxAgentConfigTime = new Date().valueOf();
                return true;
              }).catch(function () {
                return false;
              });

            case 18:
              configOK = _context4.sent;
              this.agentOK = !!configOK;
              return _context4.abrupt("return", this.agentOK);

            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function agentConfig() {
      return _agentConfig.apply(this, arguments);
    }

    return agentConfig;
  }();

  return QywxConfig;
}(WxConfig);
;
/** WxConfig 对象 单例模式 */

var configInstanse = null;
/**
 * 返回鉴权单例对象
 * @param options: Configure.Options 配置参数，只有在初次鉴权时才有效
 * @returns WxConfig 配置对象
 */

var qywx = function qywx(data) {
  var options = typeof data === 'string' ? {
    agentId: data
  } : data;
  configInstanse = configInstanse || new QywxConfig(options);
  return configInstanse;
};

export default qywx;